/**
 * Organizer admin CRUD contracts.
 *
 * A school-scoped organizer (name + optional logo) that brands event
 * collections. Mirrors the collection request shape; `name` is unique per
 * school (enforced server-side — a duplicate returns a 409, not a 500).
 */

import { z } from 'zod'

export const CreateTicketedEventOrganizerRequestSchema = z.object({
  name: z.string().min(1).max(255),
  // Cloudinary secure URL of the organizer logo (optional).
  logoUrl: z.string().url().max(1000).nullable().optional()
})
export type CreateTicketedEventOrganizerRequest = z.infer<typeof CreateTicketedEventOrganizerRequestSchema>

export const UpdateTicketedEventOrganizerRequestSchema = z.object({
  name: z.string().min(1).max(255).optional(),
  logoUrl: z.string().url().max(1000).nullable().optional()
})
export type UpdateTicketedEventOrganizerRequest = z.infer<typeof UpdateTicketedEventOrganizerRequestSchema>
